import React from 'react';
import {useDispatch, useSelector} from 'react-redux'
import fontawesome from '@fortawesome/fontawesome';


import Parameters from './components/Parameters';
import Pricing from './components/Pricing';

import {
  changeParameter,
  doQuote,
  validator,
} from './data/slice'


fontawesome.config = {
  autoReplaceSvg: true,
};

export default () => {
  const dispatch = useDispatch();

  window.myValidator = validator;

  const {
    parameters,
    quote,
  } = useSelector((state) => state.smc)

  const onChangeParameter = (name, value) => {
    dispatch(changeParameter({name, value}))
    dispatch(doQuote({name, value}))
  }

  return (
    <div className="row">
      <div className="col-lg-4">
        <div className="card parameters h-100">
          <div className="card-body">
            <Parameters
              parameters={parameters}
              onChangeParameter={onChangeParameter}
              validator={validator} />
          </div>
        </div>
      </div>
      <div className="col-lg-8">
        <Pricing
          parameters={parameters}
          quote={quote} />
      </div>
    </div>
  )
}
